module.exports = __webpack_public_path__ + "BadepallyAjay-7686e32d.webp";